<h1 class="menu-title">
  <span>Themes</span>
  <button blazeIconButton blazeIconButtonSize="lg" (click)="createThemeWithAi()">
    <mat-icon svgIcon="icon_add_16" />
  </button>
</h1>

<div class="menu-items mt-24">
  @for (theme of themes; track theme.id) {
    <div class="relative">
      <blaze-theme-editor-panel
        [theme]="theme"
        [selected]="selectedTheme?.id === theme.id"
        [applied]="appliedThemeId === theme.id"
        [modified]="isSelectedThemeChanged"
        [showDeleteButton]="selectedTheme?.scope !== 'Blaze' && !selectedTheme?.isBlazeTheme"
        [showResetButton]="selectedTheme?.scope === 'Blaze' && isSelectedThemeChanged"
        [projectId]="projectId"
        (selectionChange)="onSelectionChange(theme)"
        (delete)="deleteTheme($event)"
        (resetTheme)="resetTheme($event)"
      >
        @if (selectedTheme && theme.id === selectedTheme.id) {
          <mat-tab-group #tabs class="tabs" dynamicHeight disablePagination animationDuration="0ms">
            <mat-tab class="tab-content" label="Global">
              <blaze-theme-editor-form
                class="editor-form"
                [theme]="selectedTheme"
                [fonts]="fonts"
                (themeChange)="onThemeValueChange($event)"
              />
              @if (selectedTheme.id === theme.id) {
                <div
                  class="flex items-center justify-center w-full absolute p-2 left-0 bottom-2 h-48"
                >
                  <div
                    class="w-full flex items-center justify-between p-8 bg-overlay-light-background gap-8 relative"
                  >
                    @if (isSavingInProgress$ | async) {
                      <blaze-element-loading-indicator [isVisible]="true" />
                    }
                    @if ((isSavingInProgress$ | async) !== true) {
                      <button type="button" class="action-button save" (click)="save(true)">
                        Save as
                      </button>
                      <button
                        type="button"
                        class="action-button apply"
                        [disabled]="
                          (theme.scope === 'Blaze' || !isSelectedThemeChanged) &&
                          appliedThemeId === selectedTheme.id
                        "
                        [blazeTooltip]="
                          theme.scope === 'Blaze' &&
                          isSelectedThemeChanged &&
                          appliedThemeId === selectedTheme.id
                            ? 'This button is disabled because Blaze default themes cannot be overwritten. To save your changes, please save as a new theme.'
                            : ''
                        "
                        (click)="apply(theme)"
                      >
                        Apply
                      </button>
                    }
                  </div>
                </div>
              }
            </mat-tab>
            <mat-tab class="tab-content" label="Styles">
              <blaze-style-sheets-panel [projectId]="projectId" />
            </mat-tab>
          </mat-tab-group>
        }
      </blaze-theme-editor-panel>
    </div>
  }
</div>
